<template>
  <m-form :formModel="formModel" ref="form" />
</template>

<script>
import MForm from './m-form'

export default {
  data() {
    return {
      formModel: [
        {
          type: 'input',
          label: 'CRMZ Business Id',
          key: 'crmzBusinessId',
          rule: [
            { required: true, message: 'Can not be empty!', trigger: 'blur' },
          ],
          defaultValue: this.$route.query.businessId,
        },
        {
          type: 'select',
          label: 'Financial Statement Type',
          defaultValue: 1,
          key: 'financialStatementType',
          selectList: [
            {
              id: 1,
              name: 'Annual',
            },
            {
              id: 2,
              name: 'Interim',
            },
            {
              id: 3,
              name: 'YTD',
            },
          ],
        },
        {
          type: 'select',
          label: 'Period',
          key: 'period',
          defaultValue: 1,
          selectList: [
            {
              id: 1,
              name: 'Last',
            },
            {
              id: 2,
              name: 'Last2',
            },
            {
              id: 3,
              name: 'Last3',
            },
            {
              id: 4,
              name: 'Last4',
            },
            {
              id: 5,
              name: 'Last5',
            },
            {
              id: 6,
              name: 'Last6',
            },
            {
              id: 7,
              name: 'Last7',
            },
            {
              id: 8,
              name: 'Last8',
            },
            {
              id: 9,
              name: 'Last9',
            },
            {
              id: 10,
              name: 'Last10',
            },
          ],
        },
      ],
    }
  },
  methods: {
    async validate() {
      const result = await this.$refs.form.validateForm()
      Object.keys(result).forEach(key => {
        const value = result[key]
        if (typeof value === 'boolean') {
          value ? (result[key] = 1) : (result[key] = 0)
        }
      })
      return result
    },
  },
  components: {
    MForm,
  },
}
</script>
